import React, {useState} from 'react';
import { Button } from 'primereact/button';
import { useHistory, useLocation } from 'react-router-dom'
import Cucine from '../component/Cucine';
import NavBar from '../component/NavBar';
import ReactGA from "react-ga4";

const CucinaPage = () => {
    const history = useHistory();
    const location = useLocation();
    ReactGA.send({ hitType: "pageview", page: "/cucina", title: "Cucina" });
    const [preventivo, setPreventivo] = useState(location.state?.preventivo ||
        {
            cucine: []
        }
    );

    const handleCalcolo = () => {

        history.push("/preventivo", { preventivo: preventivo, editURL: '/cucina' })
    }

    return (
        <div >
            <NavBar />
            <>
                <div className="surface-ground px-1 py-1 md:px-4 md:py-4 ">
                    <div className='flex gap-4 pr-4'>
                        <div className='flex flex-grow-1 flex-column'>
                            <div className="text-900 font-medium text-900 text-xl mb-2">Cucine</div>
                            <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">Descrizione preventivo cucine</p>
                        </div>
                        <div className='flex-grow-0'>
                            <Button label="Genera preventivo" className="w-auto mt-3" onClick={handleCalcolo} />
                        </div>
                    </div>

                    <Cucine preventivo={preventivo}
                        onChange={(data) => setPreventivo({ ...preventivo, cucine: data })} />
                    <div className="col-12">
                    </div>

                </div>
            </>
        </div>


    )

}
export default CucinaPage